// extracted by mini-css-extract-plugin
export var backdropBlur = "_ls-0";
export var contentCard = "_ls-5";
export var frame = "_ls-2";
export var image = "_ls-4";
export var imagePane = "_ls-3";
export var modal = "_ls-1";